<div class="padding-20" id="conditionMenu" >
  <div class="ui-g-12" style="background-color: #fff;" >
    <!-- Select condition operation -->
    <div class="ui-g-12 ui-md-5" >
      <h2 id="operatorConditionLbl">{{ 'audit.selectConditionOperation' | translate }}</h2>
      <p-dropdown
        [options]="operatorBooleanCondition"
        [style]="{'width':'100%'}"
        [(ngModel)]="selectedOperatorBooleanCondition"
        [disabled]="isChallenge">
      </p-dropdown>
    </div>
    <!--<div class="ui-g-12  ui-md-5 text-center">
      <button pButton type="button"
        class="layoutDefaultFirstBtn" style="margin-top:4%; text-align: right !important;" icon="fa fa-edit" iconPos="left" label='audit.addNewCondition'
        (click)="openAddNewCondition()"></button>
      <br />
      <br />
    </div>-->
  </div>  
  <br />
  <div class="ui-g-12">
      <app-campaign-3-kontable *ngIf="show.table"
        #conditionListTable
        id="conditionListTable"
        [columns]="[
        {field: 'id_seq', title: '#', filterType: noFilter, sortable: false},
        {field: 'auditRulesConditionType', title: 'audit.conditionType',
             bodyTemplate: ruleTypeTemplateRow, filterTemplate: noFilter,filterType: noFilter },
        {field: 'description', title: 'audit.ruleConditionDesc', filterTemplate: noFilter, filterType: noFilter },
        {field: 'conditionEntityId', title: 'audit.ruleConditionItemCondition', 
          bodyTemplate: itemConditionTemplateRow, filterTemplate: noFilter,filterType: noFilter}

        ]"
        [service]="ruleConditionsService"
        [paginationType]="paginationType"
        [showRecoverButton]="false"
        [showInfoButton]="false"
        [showAddButton]="false"
        [showDeleteButton]="false"
        [showDetailsButton]="false"
        [showEditButton]="false"
        [additionalRowCommands]="conditions"
        [filterBySingleColumn]="true"
        [expandTable]="false"
        [fetchActionListAsap]="false"
        [additionalRowCommands]="conditions"
        [showGlobalFilter]="false"
        [showResetFiltersBtn]="false"
        [showRowButtons]="true"
      >
        <ng-template #ruleTypeTemplateRow let-row>
          <span>{{getConditionTypeDescription(row)}}</span>
        </ng-template>
        <ng-template #conditionList data-testid="conditionList" let-row>
          <span style="text-transform: uppercase;">{{ getConditionTypeDescription(row) }}</span>
        </ng-template>
        <ng-template #itemConditionTemplateRow let-row>
          <span>{{getItemConditionDescription(row)}}</span>
        </ng-template>

        <ng-template #noFilter data-testid="noFilter" let-col>

        </ng-template>

        <ng-template #conditions let-row>
          <div class="detail-btn-container">
            <button class="btn-details" *ngIf="!isChallenge && row.flg_state === '0' && row.flg_dpl === '0'" (click)="openEditCondition(row.id)">
              <i class="pi pi-pencil icon-size"></i>
            </button>
            <button class="btn-details" *ngIf="!isChallenge && row.flg_state === '0' " (click)="onRemoveRuleCondition(row.id)">
              <i class="pi pi-trash icon-size"></i>
            </button>
          </div>
        </ng-template>
      </app-campaign-3-kontable>
        <div class="ui-g-12 text-center">
          <button pButton type="button" *ngIf="!isChallenge"
            class="layoutDefaultFirstBtn" icon="fa fa-edit" iconPos="left" label="{{ 'audit.addNewCondition' | translate }}"
            (click)="openAddNewCondition()"></button>
          <br />
          <br />
        </div>
    </div>
</div>

<p-dialog
class="new-condition-dialog"
*ngIf="showAddNewCondition"
[(visible)]="showAddNewCondition"
[modal]="true"
[positionTop]="50"
[minWidth]="700"
[width]="800"
[height]="800"
[draggable]="false"
[responsive]="true"
[resizable]="false"
(onHide)="closeAddNewCondition()"
>
<app-audit-new-condition
[isPopUp]="true"
[clusterOption]="clusterOption"
[clusterOptionActive]="clusterOptionActive"
[touchpointOption]="touchpointOption"
[sourceSystemOption]="sourceSystemOption"
[acmList]="acmList"
[acmListFull]="acmListFull"
(closePopUp)="closeAddNewCondition($event)"
[auditRuleObject]="auditRuleObject"
[ui_mode]="ui_mode"
[listReasonsFiltered]="listReasonsFiltered"
[listReasonsFull]="listReasonsFull"
[auditRuleConditionEditId]="auditRuleConditionEditId"
[conditionsTypeCombo]="conditionsTypeCombo"
[conditionsType]="conditionsType"
[ruleId]="ruleId"
[selectedOperatorBooleanCondition]="selectedOperatorBooleanCondition"
(conditionObjectChanged)="onConditionObjectChanged($event)">
</app-audit-new-condition>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-condition/audit-condition.component.html